




































































































import Vue from 'vue';

import { IBranch } from '@/types';

import bus from '@/bus';
import { appStoreMapper } from '@/store/appstore';
import { mapsStoreMapper } from '../store';
import getWorkingTimeFormatted from '@/utils/getWorkingTimeFormatted';
import getBranchScheduleFormatted from '@/utils/getBranchScheduleFormatted';
import { sendStat } from '@/misc';

import MapBlock from '@/components/MapBlock.vue';
import MapsSheetBranches from './MapsSheetBranches.vue';
import MapsSheetBranchInfo from './MapsSheetBranchInfo.vue';
import BranchList from "@/components/branch-list.vue";

export default Vue.extend({
  name: 'maps2',
  components: { MapBlock, MapsSheetBranches, MapsSheetBranchInfo, BranchList },
  data: () => ({
    map: null as Nullable<any>,
    mapCenter: {
      lat: 0,
      lng: 0,
    } as IMapPosition,
    markersList: [] as Array<[any, IMapPoint]>,
    branch: null as Nullable<IBranch>,
    branchSelected: null as Nullable<IBranch>,
    stepOpened: false,
    zoomToCurrentPosition: false,
    waitingForCoordinates: false,
    branchOpened: false,
    mapIsVisible: false,
  }),
  created() {
    this.mapCenter = {
      lat: parseFloat(this.settings.center?.lat || '0'),
      lng: parseFloat(this.settings.center?.lng || '0'),
    };

    this.mapIsVisible = this.settings.mapAndListView ? this.settings.mapAndListDefaultView !== 'list' : true;
  },
  mounted() {
    bus.$emit('maps:branches:sheet-open');
    bus.$on('backButtonOverride', this.goBack);
  },
  beforeDestroy() {
    bus.$emit('maps:branches:sheet-close');
    bus.$off('backButtonOverride', this.goBack);
  },
  computed: {
    pointsNumber(): any {
      const $style = (this as any).$style;

      return {
        [$style.more]: this.mapPoints.length > 3,
        [$style.three]: this.mapPoints.length === 3,
        [$style.two]: this.mapPoints.length === 2,
        [$style.one]: this.mapPoints.length === 1,
        [$style.zero]: this.mapPoints.length === 0,
      };
    },
    mapPoints(): IMapPoint[] {
      return this.visibleBranches.map((branch) => ({
        id: branch.idBranch as unknown as number,
        position: { lat: parseFloat(branch.lat), lng: parseFloat(branch.lng) },
        shape: branch.shape,
      }));
    },
    selectedMapPoint(): Nullable<IMapPoint> {
      if (this.branchSelected) {
        return {
          id: this.branchSelected.idBranch,
          position: {
            lat: parseFloat(this.branchSelected.lat),
            lng: parseFloat(this.branchSelected.lng),
          },
        };
      } else if (this.zoomToCurrentPosition) {
        return {
          id: 0,
          position: {
            lat: this.currentCoords.lat,
            lng: this.currentCoords.lng,
          },
        };
      }

      return null;
    },
    ...appStoreMapper.mapState(['currentCoords']),
    ...appStoreMapper.mapGetters(['visibleBranches', 'appSettings', 'timeZoneOptions']),
    ...mapsStoreMapper.mapGetters(['settings']),
  },
  methods: {
    goBack() {
      bus.$emit('maps:branches:sheet-close');
      this.$f7.views.current.router.back();
    },
    getCoords({ silent }: { silent?: boolean } = {}) {
      this.waitingForCoordinates = true;

      this.getCurrentCoordinates({ silent })
        .then((coords) => {
          const _coords = coords as Nullable<Coords>;

          if (_coords && !silent) {
            if (_coords.lat || _coords.lng) {
              this.zoomToCurrentPosition = true;

              this.mapCenter = {
                lat: parseFloat(_coords.lat as unknown as string),
                lng: parseFloat(_coords.lng as unknown as string),
              };
            } else {
              this.$f7.dialog.alert(
                this.$t('global.location.error.text').toString(),
                this.$t('global.location.error.title').toString(),
              );
            }
          }
        })
        .finally(() => {
          this.waitingForCoordinates = false;
        });
    },
    onMapInit(map: any) {
      this.map = map;
      this.getCoords({ silent: true });
    },
    onMarkerList(list: any[]) {
      this.markersList = list;
    },
    onMarkerClick(point: IMapPoint) {
      const branch = this.visibleBranches.find(
        (b) => (b.idBranch as unknown as number) === point.id,
      ) as IBranch;

      this.onBranchClick(branch);
    },
    onBranchClick(branch: IBranch) {
      this.branchSelected = branch;
      this.branchOpened = true;

      bus.$emit('maps:branches:sheet-close');

      if (this.mapIsVisible) {
        this.zoomToCurrentPosition = false;

        this.mapCenter = {
          lat: parseFloat(branch.lat),
          lng: parseFloat(branch.lng),
        };

        this.$nextTick(() => {
          let panByY;

          switch (this.visibleBranches.length) {
            case 1:
              panByY = 70;
              break;

            case 2:
              panByY = 50;
              break;

            case 3:
              panByY = 20;
              break;

            default:
              panByY = 0;
          }

          this.map.panBy(0, panByY);
        });
      }
    },
    pageBeforeOut() {
      this.branchOpened = false;
    },
    pageAfterIn() {
      if (this.appSettings.logMapCalls) {
        const data = { action: 'maps:open', id: 0 };
        if (window.devMode) console.warn('send stat', data);
        sendStat(data, this.$store as any);
      }
    },
    workingTimeFormatted(schedule: WorkingSchedule): string {
      return getWorkingTimeFormatted(schedule, this.timeZoneOptions, this.$i18n, 'work');
    },
    onScheduleClick(branch: IBranch, e: Event) {
      e.stopPropagation();

      this.$f7.dialog.alert(
        getBranchScheduleFormatted(branch, this.timeZoneOptions, this.$i18n, 'work'),
        this.$t('global.branch.workingTime.workingTime').toString(),
      );
    },
    ...appStoreMapper.mapActions(['getCurrentCoordinates']),
  },
  watch: {
    branchOpened() {
      if (!this.branchOpened) {
        bus.$emit('maps:branches:sheet-open');
        if (this.stepOpened) {
          bus.$emit('maps:branches:step-open');
        }
      }
    },
    mapIsVisible() {
      this.$nextTick(() => {
        this.branchOpened = false;
        this.branchSelected = null;

        bus.$emit('maps:branches:sheet-open');
      })
    }
  },
});
